import { useCallback } from 'react';
import SimpleMenu from 'components/SimpleMenu';
import { integrationForceUpdate } from 'thunk';
import useLocalDispatch from 'hooks/useLocalDispatch';
import { DataType } from '@constants';
import * as useDynamicModal from 'components/DynamicModalProvider/useDynamicModal';
import { useNotification } from 'hooks/useNotification';

const stateId = 'entity-retry-force-update';
const noop = () => {};

export const useEntityRetryMenu = () => {
  const { dispatchLocal, selectLocalData } = useLocalDispatch();
  const { openModal } = useDynamicModal.useDynamicModal();
  const { showSuccess, showError } = useNotification();

  const openEntityRetryMenu = useCallback(
    ({
      target,
      dataType,
      mosaicTeamId,
      targetServiceId,
      isTwoWaySync,
    }: {
      target: HTMLElement;
      dataType: DataType;
      mosaicTeamId: number;
      targetServiceId: number;
      isTwoWaySync: boolean;
    }) => {
      const menuItems = [
        {
          label: 'Retry all on Mosaic',
          onClick: () => {
            const params = {
              targetServiceId,
              targetSide: false,
              mosaicTeamId,
              dataType,
              ignoreWaitingResponse: false,
            };
            dispatchLocal(integrationForceUpdate, {
              params,
              stateId,
              onSuccessCallback: ({ response }) => {
                const error = response.data?.errors?.[0];
                if (error) {
                  // ✅ FIX: Replace alert() with toast notification
                  showError(`Failed to trigger force update. ${error}`);
                } else {
                  // ✅ FIX: Replace alert() with toast notification
                  showSuccess('Successfully triggered force update.');
                }
              },
            });
          },
        },
        ...(isTwoWaySync && dataType === DataType.TimeEntry
          ? [
              {
                label: 'Retry all on Target Side',
                onClick: () => {
                  const params = {
                    targetServiceId,
                    targetSide: true,
                    mosaicTeamId,
                    dataType,
                    ignoreWaitingResponse: false,
                  };
                  dispatchLocal(integrationForceUpdate, {
                    params,
                    stateId,
                    onSuccessCallback: ({ response }) => {
                      const error = response.data?.errors?.[0];
                      if (error) {
                        // ✅ FIX: Replace alert() with toast notification
                        showError(`Failed to trigger force update. ${error}`);
                      } else {
                        // ✅ FIX: Replace alert() with toast notification
                        showSuccess('Successfully triggered force update.');
                      }
                    },
                  });
                },
              },
            ]
          : []),
      ];

      openModal({
        modal: ({ isOpen: _isOpen, toggle }) => {
          return (
            <SimpleMenu
              anchorEl={target}
              items={menuItems}
              handleClick={noop}
              handleClose={toggle}
            />
          );
        },
      });
    },
    [dispatchLocal, openModal, showSuccess, showError],
  );

  return {
    openEntityRetryMenu,
  };
};
